import upperFirst from 'lodash/upperFirst';
import { memo } from 'react';

import type { Appointment } from '@wecasa/common/src/types/commons';
import { getAppointmentsSortedByDayDeprecated } from '@wecasa/common/src/utils/appointment';
import { FORMATS, formatDateDeprecated } from '@wecasa/common/src/utils/date';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { Day, DaysList, Slots } from '../../../../common/common';
import Slot from '../../../../common/sections/appointments/slot';

type SingleCleaningAppointmentDetailsProps = {
  appointment: Appointment;
};

const SingleCleaningAppointmentDetails = ({
  appointment: { primary, secondary },
}: SingleCleaningAppointmentDetailsProps) => (
  <DaysList>
    {getAppointmentsSortedByDayDeprecated(primary, secondary).map(({ day, slots }) => (
      <Day key={day.toISOString()}>
        <Text.MDBold>{day ? upperFirst(formatDateDeprecated(day, FORMATS.DATE.WEEKDAY_DAY_MONTH)) : ''}</Text.MDBold>
        <Slots>
          {slots.map(({ text, isPrimary, label }) => (
            <Slot key={label} text={text} isPrimary={isPrimary} label={label} />
          ))}
        </Slots>
      </Day>
    ))}
  </DaysList>
);

export default memo(SingleCleaningAppointmentDetails);
